module.exports = __webpack_public_path__ + "img/aha.90d05c73.svg";